import { all } from 'redux-saga/effects';

import dialogSendPayment from './dialogDetailsSlips';

function* watch() {
  yield all([dialogSendPayment.saga.watch()]);
}

export default {
  watch,
};
